import type { ILanguageResources, ITranslationModule } from '../../interfaces';
import { interpolate } from '../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.purchaseOrders.PurchaseOrderSummaryTable.';
  public static readonly systemPurchaseOrderNumberTitle = `${Id.prefix}systemPurchaseOrderNumberTitle`;
  public static readonly franchiseePurchaseOrderNumberTitle = `${Id.prefix}franchiseePurchaseOrderNumberTitle`;
  public static readonly purchaseOrderTitleTitle = `${Id.prefix}purchaseOrderTitleTitle`;
  public static readonly statusTitle = `${Id.prefix}statusTitle`;
  public static readonly amountTitle = `${Id.prefix}amountTitle`;
}

export class LangPurchaseOrderSummaryTable {
  private constructor() {}
  public static systemPurchaseOrderNumberTitle(): string {
    return interpolate(Id.systemPurchaseOrderNumberTitle);
  }
  public static franchiseePurchaseOrderNumberTitle(): string {
    return interpolate(Id.franchiseePurchaseOrderNumberTitle);
  }
  public static purchaseOrderTitleTitle(): string {
    return interpolate(Id.purchaseOrderTitleTitle);
  }
  public static statusTitle(): string {
    return interpolate(Id.statusTitle);
  }
  public static amountTitle(): string {
    return interpolate(Id.amountTitle);
  }
}

export class PurchaseOrderSummaryTableModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // Table columns
    register.add(
      Id.systemPurchaseOrderNumberTitle,
      "System {{glossary 'purchase-order-abbrev'}} No.",
      'Column title for system purchase order number'
    );
    register.add(
      Id.franchiseePurchaseOrderNumberTitle,
      "{{glossary 'franchisee'}} {{glossary 'purchase-order-abbrev'}} No.",
      'Column title for franchisee purchase order number'
    );
    register.add(
      Id.purchaseOrderTitleTitle,
      "{{glossary 'purchase-order'}} Title",
      'Column title for purchase order title'
    );
    register.add(Id.statusTitle, 'Status', 'Column title for purchase order status');
    register.add(Id.amountTitle, 'Amount', 'Column title for purchase order amount');
  }
}
